import { useNavigate, useParams } from "react-router-dom";
import MedicalRecordsSection from "../components/medical-records/medical-records-section";
import SymptomSummaryCard from "../components/symptoms/symptom-summary-card";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadSymptoms from "../hooks/useLoadSymptoms";
import { buildRecordDetailPath } from "#/lib/medicalRecords";

const SymptomsPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();
  const { symptoms, isLoading, error } = useLoadSymptoms(userId);
  useSetPageContext(symptoms);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta">
          Failed to load symptoms
        </Typography>
      </div>
    );
  }

  const hasSymptoms = symptoms.length > 0;

  return (
    <MedicalRecordsSection
      title="Symptoms"
      buttonLabel="Add Symptom"
      uploadMessage={`Add symptom information to this user's medical records ${
        userId ?? ""
      }`}
      hasRecords={hasSymptoms}
      emptyTitle="No symptoms listed."
      emptyDescription="To add a symptom take a photo or ask the chat below to add it."
    >
      {hasSymptoms
        ? symptoms.map((symptom) => (
            <div
              key={symptom.id}
              id={`record-symptom-${symptom.id}`}
              className="file-record-anchor block scroll-mt-24"
            >
              <SymptomSummaryCard
                symptom={symptom}
                onClick={() => {
                  const detailPath = buildRecordDetailPath(
                    "symptoms",
                    symptom.id,
                    userId
                  );
                  if (!detailPath) return;
                  navigate(detailPath, { state: { record: symptom } });
                }}
              />
            </div>
          ))
        : null}
    </MedicalRecordsSection>
  );
};

export default SymptomsPage;
